module.exports = __webpack_public_path__ + "static/media/delete-icon.9ed10d0c.svg";